<template>
  <div class="col-24">
    <b-modal
      size="xl"
      centered
      no-close-on-backdrop
      ok-title="Enviar"
      id="modal-edit-scope"
      ref="modalEdit"
      modal
      @hide="closeModalScope"
      :title="activeEditScope ? $ml.get('editScope') : $ml.get('scopeDetails')"
    >
      <div class="card card-body d-flex w-100">
        <div class="row w-100 d-flex align-items-center mb-4" style="gap: 10px">
          <div class="col-8">
            <input
              maxlength="100"
              type="text"
              class="form-control"
              v-model="txtScop"
              :placeholder="$ml.get('informTheScope')"
            />
            <transition name="fade">
              <label
                v-if="validateScopeError && !$v.txtScop.required"
                class="lblError"
                v-text="$ml.get('theScopeAddressMustBeInformed')"
                >Informe o endereço do escopo</label
              >
              <label
                class="lblError"
                v-text="$ml.get('minMaxScopeCaracter')"
                v-if="validateScopeError && !$v.txtScop.minLength"
                >O escopo deve ter entre 3 e 40 caracteres</label
              >
            </transition>
          </div>

          <div class="col-8">
            <multiselect
              v-model="selectedScopeType"
              label=""
              :custom-label="nameLang"
              :options="selectScopeType"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$ml.get('scopeType')"
            >
            </multiselect>
            <transition name="fade">
              <label
                v-if="validateScopeError && !$v.selectedScopeType.required"
                class="lblError"
                v-text="$ml.get('selectScopeType')"
                >Selecione o tipo de escopo</label
              >
            </transition>
          </div>

          <div class="col">
            <input
              v-show="selectedScopeType === 'others'"
              type="text"
              class="form-control"
              v-model="othersDetails"
              placeholder="Descreva o tipo do escopo"
            />
            <div
              class="mb-2"
              v-show="error_obs_geral && selectedScopeType === 'others'"
            >
              <label class="lblError" v-text="$ml.get('lblErrorRequiredObs')"
                >Por favor, insira uma observação geral.</label
              >
            </div>
          </div>
        </div>

        <div class="col">
          <form>
            <div class="col">
              <svg
                v-show="!htmlText"
                @click="viewHtml()"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye.svg"
                  width="24"
                  height="24"
                />
              </svg>
              <svg
                v-show="htmlText"
                @click="htmlText = ''"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye-slash.svg"
                  width="24"
                  height="24"
                />
              </svg>

              <textarea
                v-show="!htmlText"
                class="form-control-textarea w-100 text-are-mark"
                v-model="scopeDetails"
                ref="textarea"
                :placeholder="$ml.get('includeInfoScope')"
                rows="5"
                maxlength="300"
              >
              </textarea>
              <div v-if="!htmlText" class="col d-flex justify-content-end">
                <span
                  style="
                    font-size: 12px;
                    color: rgb(82, 82, 82);
                    font-weight: 400;
                  "
                  >{{ $ml.get("characters") }}
                  {{ scopeDetails.length }}/300</span
                >
              </div>
              <div
                v-show="htmlText"
                class="form-control w-100 h-100"
                v-html="htmlText"
              ></div>
            </div>
          </form>
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center" style="gap: 10px">
            <input
              type="text"
              v-model="tag"
              class="form-control"
              :placeholder="$ml.get('includeTech')"
              @keyup.enter="addTag"
            />
            <button
              @click="addTag"
              class="btn"
              :disabled="!tag"
              v-text="$ml.get('include')"
            >
              Incluir
            </button>
          </div>
          <div class="col-24 mb-2">
            <label
              v-if="errorLimitTag"
              class="lblError"
              v-text="$ml.get('maxTech')"
              >O máximo permitido é de 10 tecnologias por escopo.</label
            >
          </div>
        </div>
        <div
          v-if="tagList.length"
          class="d-flex align-items-center mt-3"
          style="gap: 10px; flex-wrap: wrap"
        >
          <div v-for="(tag, index) in tagList" :key="index">
            <div class="tagsListReport">
              <span>{{ tag }}</span>
              <div @click="removeTags(tag)" class="close">X</div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button
          class="float-right btn"
          style="background: #730ba9; border: none"
          size="sm"
          variant="primary"
          @click="activeEditScope ? savePlan() : verifyPlan()"
        >
          {{ activeEditScope ? $ml.get("save") : $ml.get("add") }}
        </b-button>
        <b-button
          class="float-right btn-outline-extra"
          size="sm"
          variant="primary"
          @click="closeModalScope"
        >
          {{ $ml.get("toClose") }}
        </b-button>
      </template>
    </b-modal>
    <div class="d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('scope')">Escopo</strong>
          </h2>
          <p v-if="!view" class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('limitScopePentest')"
            >
              Defina os escopos a serem testados
            </span>
          </p>
          <p v-else class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('scopeListOfThePentest')"
            >
              Lista de escopos do pentest
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3" style="position: relative">
        <p
          v-if="!view"
          class="pl-3 mb-3"
          v-text="$ml.get('selectedScopePentest')"
        >
          Selecione os escopos para teste
        </p>
        <p
          v-else
          class="m-0 pl-3"
          v-text="$ml.get('delimitationOfDomainsSubdomains')"
        >
          Delimitação de domínios, subdomínios, aplicativos e outros
        </p>
        <div v-if="!view" class="d-flex pl-3 w-100">
          <div class="row w-100 d-flex" style="flex-wrap: wrap; gap: 5px">
            <div class="col-lg-7 col-md-7 pr-3 pb-2 col-24 minInput">
              <input
                maxlength="100"
                type="text"
                class="form-control"
                v-model="txtScop"
                :placeholder="$ml.get('informTheScope')"
              />
              <transition name="fade">
                <div class="mb-2">
                  <label
                    v-if="validateScopeError && !$v.txtScop.required"
                    class="lblError"
                    v-text="$ml.get('theScopeAddressMustBeInformed')"
                    >Informe o endereço do escopo</label
                  >
                  <label
                    class="lblError"
                    v-text="$ml.get('minMaxScopeCaracter')"
                    v-if="validateScopeError && !$v.txtScop.minLength"
                    >O escopo deve ter entre 3 e 40 caracteres</label
                  >
                </div>
              </transition>
            </div>

            <div class="col d-flex" style="gap: 10px">
              <div class="col-12">
                <multiselect
                  v-model="selectedScopeType"
                  label=""
                  :custom-label="nameLang"
                  :options="selectScopeType"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="$ml.get('scopeType')"
                >
                </multiselect>
                <transition name="fade">
                  <div class="mb-2">
                    <label
                      v-if="
                        validateScopeError && !$v.selectedScopeType.required
                      "
                      class="lblError"
                      v-text="$ml.get('selectScopeType')"
                      >Selecione o tipo de escopo</label
                    >
                  </div>
                </transition>
              </div>
              <div class="col">
                <input
                  v-show="selectedScopeType === 'others'"
                  type="text"
                  class="form-control"
                  v-model="othersDetails"
                  :placeholder="$ml.get('describeScopeType')"
                />
                <div
                  class="mb-2"
                  v-show="error_obs_geral && selectedScopeType === 'others'"
                >
                  <label
                    class="lblError"
                    v-text="$ml.get('lblErrorRequiredObs')"
                    >Por favor, insira uma observação geral.</label
                  >
                </div>
              </div>
            </div>

            <div class="col-6 d-flex justify-content-end pointer">
              <button
                v-if="!activeEditScope"
                style="height: 38.99px"
                class="btn"
                @click="verifyPlan()"
                v-text="$ml.get('include')"
              >
                Incluir
              </button>
            </div>
          </div>
        </div>
        <div class="ml-3 d-flex w-100 mb-2 pr-3 mb-3 mt-3">
          <a
            v-if="!view"
            class="moreInfo"
            @click="createScope = true"
            v-b-modal.modal-edit-scope
            v-text="$ml.get('includeMoreDetails')"
            >Acrescentar mais detalhes...</a
          >
        </div>
        <div class="card card-body ml-3 p-0 d-flex w-100">
          <div v-if="!listScop.length" class="d-flex justify-content-center">
            <h6 class="size-1_4 p-4" v-text="$ml.get('addTheScopesHere')">
              Adicione os escopos aqui!
            </h6>
          </div>
          <table v-else v-show="listScop.length" class="mb-2">
            <thead>
              <tr>
                <th class="col-10" v-text="$ml.get('scope')">Escopo</th>
                <th class="col-10" v-text="$ml.get('type')">Tipo</th>
                <th class="col-2"></th>
                <th class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listScop" :key="index">
                <td class="col-10 text-break">
                  <p class="m-0">
                    <strong>{{ item.description }}</strong>
                  </p>
                  <br />
                  <div v-if="item.scope_details" style="max-width: 380px">
                    <p v-html="item.scope_details"></p>
                  </div>
                  <div
                    v-if="item?.scope_tags"
                    class="d-flex align-items-center"
                    style="gap: 10px; flex-wrap: wrap"
                  >
                    <div v-for="(tag, index) in item.scope_tags" :key="index">
                      <div class="tagsListReport">{{ tag }}</div>
                    </div>
                  </div>
                </td>
                <td class="col-10">
                  <strong>{{ nameLang(item.type) }}</strong>
                  <div v-show="item.type === 'others'" style="margin-top: 19px">
                    {{ item.othersDetails }}
                  </div>
                </td>

                <td
                  class="col pl-0 d-flex justify-content-end"
                  style="gap: 10px"
                  v-if="!view"
                >
                  <a
                    v-b-modal.modal-edit-scope
                    class="pointer"
                    @click="editScop(item, index), (createScope = false)"
                  >
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../../src/assets/icons/edit.png"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                  <a class="pointer" @click="removeScop(index)">
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../../src/assets/icons/trash-alt.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="error" class="row ml-3 mt-1">
          <label class="lblError" v-text="$ml.get('addScopeToContinue')"
            >Por favor, adicione um escopo para continuar.</label
          >
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  name: "Scope",
  props: {
    number: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    view: {
      type: Boolean,
      required: false,
      default: false,
    },
    dataPentest: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  components: {},
  data() {
    return {
      htmlText: "",
      listScop: [],
      createScope: false,
      activeEditScope: false,
      idEditScope: null,
      maxRowsError: "",
      errorLimitTag: "",
      validateScopeError: false,
      txtScop: "",
      tag: "",
      tagList: [],
      selectedScopeType: "",
      scopeDetails: "",
      othersDetails: "",

      selectScopeType: [
        "inclusionInWebApplication",
        "inclusionInMobileApplication",
        "loggedArea",
        "other",
      ],

      scopeMaxLengt: false,

      error_obs_geral: false,
    };
  },
  validations: {
    txtScop: { required, minLength: minLength(3) },
    selectedScopeType: { required },
    listScop: { required },
  },

  watch: {
    othersDetails() {
      this.error_obs_geral = false;
    },
    scopeDetails() {
      this.maxRowsError = "";
    },

    tagList() {
      this.errorLimitTag = "";
    },
    listScop: {
      handler() {
        this.$emit("getListScop", this.listScop);
      },
      deep: true,
    },
    dataPentest: {
      handler() {
        this.listScop = this.dataPentest.scopes;
      },
      deep: true,
    },
  },
  methods: {
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.scopeDetails);
    },
    addTag() {
      if (this.tagList.includes(this.tag)) return;

      const maxTags = 9;
      if (this.tagList.length > maxTags) {
        this.errorLimitTag = "ERROR";
        return;
      }

      this.tagList = [...this.tagList, this.tag];
      this.tag = "";
    },

    removeTags(tag) {
      this.tagList = this.tagList.filter((t) => t != tag);
    },

    editScop(element, idx) {
      this.activeEditScope = true;
      this.idEditScope = idx;

      this.tagList = element.scope_tags ?? [];
      this.scopeDetails = element.scope_details ?? "";
      this.othersDetails = element.othersDetails ?? "";

      this.txtScop = element.description ?? "";
      this.selectedScopeType = element.type ?? "";
    },

    savePlan() {
      var self = this;
      const maxRows = 9;
      const qntRows = self.scopeDetails.split("\n").length - 1;
      if (qntRows > maxRows) {
        self.maxRowsError = "ERROR";
        return;
      }

      this.listScop[this.idEditScope].description = this.txtScop ?? "";
      this.listScop[this.idEditScope].scope_details = this.scopeDetails ?? "";
      this.listScop[this.idEditScope].scope_tags = this.tagList ?? [];
      this.listScop[this.idEditScope].type = this.selectedScopeType ?? [];
      this.listScop[this.idEditScope].othersDetails = this.othersDetails ?? "";

      this.closeModalScope();
    },

    closeModalScope() {
      if (this.createScope) return this.$refs.modalEdit.hide();
      this.tag = "";
      this.txtScop = "";
      this.scopeDetails = "";
      this.tagList = [];
      this.selectedScopeType = "";
      this.othersDetails = "";

      this.activeEditScope = false;
      this.idEditScope = null;

      this.$refs.modalEdit.hide();
    },

    // Altera o idioma dos itens do select
    nameLang(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },

    async verifyPlan() {
      this.error_obs_geral = false;
      var self = this;
      // stop here if form is invalid
      if (this.selectedScopeType === "others" && !this.othersDetails?.trim()) {
        this.error_obs_geral = true;
        return;
      }

      this.$v.$touch();

      if (this.$v.txtScop.$error || this.$v.selectedScopeType.$error) {
        this.validateScopeError = true;
        return;
      }

      self.addScop();
    },

    async addScop() {
      var self = this;

      const maxRows = 9;
      const qntRows = self.scopeDetails.split("\n").length - 1;
      if (qntRows > maxRows) {
        self.maxRowsError = "ERROR";
        return;
      }

      let newItem = {
        description: this.txtScop,
        scope_details: this.$utils.convertMarkedOld(this.scopeDetails),
        scope_tags: this.tagList,
        type: this.selectedScopeType,
      };

      if (this.selectedScopeType === "others") {
        newItem.scope_others = this.othersDetails;
      }

      this.tagList = [];
      this.scopeDetails = "";
      this.othersDetails = "";
      let diference = false;

      this.closeModalScope();

      await this.listScop.forEach((element) => {
        if (element.description === newItem.description) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("cannotEnterEqualScopes"),
          });
          diference = true;
          return;
        }

        if (JSON.stringify(element) === JSON.stringify(newItem)) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("cannotEnterEqualScopes"),
          });
          diference = true;
          return;
        }
      });

      this.validateScopeError = false;
      if (!diference) {
        this.txtScop = "";
        this.selectedScopeType = null;
        this.listScop.push(newItem);
      }
    },

    removeScop(item) {
      this.listScop[item].status = "inactive";
      this.listScop.splice(item, 1);
    },
  },
};
</script>
<style scoped>
.close {
  cursor: pointer;
  color: #8a0ba9;
  font-weight: 500;
  font-size: 0.6rem;
}
.close:hover {
  color: #390546;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #9b9b9b #f1f1f1;
}
.moreInfo {
  cursor: pointer;
  font-weight: 400;
  color: #730ba9;
  transition: all 0.2s;
}
.moreInfo:hover {
  color: #b21fcc !important;
}
.minInput {
  min-width: 180px;
}
</style>
